import React, { FC } from 'react';

// Externals
import { useIntl } from 'react-intl';

// Material
import {
  Box,
  Paper,
  makeStyles,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// Models
import { StationsVisibility, StationType, StationTypes } from 'app/models/station.type';
import OpenButton from './open_button';

// Styles
const useStyles = makeStyles((theme) => ({
  box: {
    position: 'absolute',
    right: 10,
    bottom: 20,
    zIndex: 999
  },
  [theme.breakpoints.down('xs')]: {
    box: {
      position: 'absolute',
      right: 10,
      bottom: 20,
      zIndex: 999
    }
  },
  paper: {
    position: 'relative',
    padding: theme.spacing(1),
    minWidth: 'unset',
    minHeight: 'unset',
    zIndex: 999,
    backgroundColor: '#FFFFFFAA',
    display: 'flex',
    flexDirection: 'column'
  },
  formItem: {
    marginBottom: 8,
    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      marginRight: 0
    }
  },
  radio: {
    padding: 0,
    paddingRight: theme.spacing(1)
  },
  closeIcon: {
    padding: 0,
    alignSelf: 'center'
  },
  [theme.breakpoints.up('sm')]: {
    closeIcon: {
      display: 'none'
    }
  }
}));

interface FilterProps {
  showData: StationsVisibility;
  setShowData: (type: StationType, value: boolean) => void;
}

const Filter: FC<FilterProps> = ({ showData, setShowData }) => {
  const classes = useStyles();
  const intl = useIntl();

  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));

  const [open, setOpen] = React.useState(upSm);

  React.useEffect(() => {
    setOpen(upSm);
  }, [upSm]);

  const selected = showData[StationTypes.School]
    ? StationTypes.School
    : StationTypes.Hospital;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedType = event.target.value as StationType;
    setShowData(StationTypes.School, selectedType === StationTypes.School);
    setShowData(StationTypes.Hospital, selectedType === StationTypes.Hospital);
  };

  if (!open) {
    return <OpenButton onClick={() => setOpen(true)} />;
  }

  return (
    <Box className={classes.box}>
      <Paper className={classes.paper}>
        <RadioGroup value={selected} onChange={handleChange}>
          <Typography variant="body1" className={classes.formItem}>
            <FormControlLabel
              value={StationTypes.School}
              control={<Radio className={classes.radio} />}
              label={intl.formatMessage({ id: 'Map.Filter.ShowSchools', defaultMessage: 'Écoles' })}
            />
          </Typography>
          <Typography variant="body1" className={classes.formItem}>
            <FormControlLabel
              value={StationTypes.Hospital}
              control={<Radio className={classes.radio} />}
              label={intl.formatMessage({ id: 'Map.Filter.ShowHospital', defaultMessage: 'Établissements de santé' })}
            />
          </Typography>
        </RadioGroup>

        <IconButton component="span" className={classes.closeIcon} onClick={() => setOpen(false)}>
          <CloseIcon titleAccess="Close" />
        </IconButton>
      </Paper>
    </Box>
  );
};

export default Filter;
